import Slides from './components';

export default Slides;
